var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwostars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5701 23.2622L22.0599 19.4835H15.2741L13 12.8528L10.7259 19.4835H3.94006L9.42992 23.2622L7.22348 29.6956L13 25.7195L18.7765 29.6955L16.5701 23.2622ZM20.1464 24.4425L21.9843 29.8012C22.8001 32.1798 20.0089 34.1858 17.9018 32.7355L13 29.3615L8.09818 32.7355C5.99105 34.1858 3.19995 32.1797 4.0157 29.8012L5.85357 24.4425L1.13145 21.1922C-0.992984 19.73 0.0732067 16.4835 2.67787 16.4835H8.58326L10.4639 10.9999C11.2754 8.63382 14.7246 8.63382 15.5361 10.9999L17.4167 16.4835H23.3221C25.9268 16.4835 26.993 19.73 24.8685 21.1922L20.1464 24.4425Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0851 23.2622L43.5749 19.4835H36.7891L34.515 12.8528L32.2409 19.4835H25.455L30.9449 23.2622L28.7385 29.6956L34.515 25.7195L40.2915 29.6955L38.0851 23.2622ZM41.6614 24.4425L43.4993 29.8012C44.315 32.1798 41.5239 34.1858 39.4168 32.7355L34.515 29.3615L29.6132 32.7355C27.506 34.1858 24.7149 32.1797 25.5307 29.8012L27.3686 24.4425L22.6464 21.1922C20.522 19.73 21.5882 16.4835 24.1929 16.4835H30.0982L31.9789 10.9999C32.7904 8.63382 36.2396 8.63382 37.051 10.9999L38.9317 16.4835H44.8371C47.4418 16.4835 48.508 19.73 46.3835 21.1922L41.6614 24.4425Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwostars);
export default __webpack_public_path__ + "static/media/twostars.22f61de13dfd9787d14fabcc7e720fdf.svg";
export { ForwardRef as ReactComponent };